import CourseEditorPage from './CourseEditorPage';

export default function EditCoursePage() {
  return <CourseEditorPage />;
}
